import React from 'react';
import './Introduction.css';

const Introduction = () => {
  return (
    <section id="introduction" className="introduction">
      <h2>介绍</h2>
      <p>
        MSAQE是复旦大学发起的一项开创性项目，基于游客评论，利用自主研发的人工智能模型，对景区的多个细粒度质量维度进行系统评估。该系统可提供精准的质量分析，助力管理者和相关方做出更明智的决策。
      </p>
    </section>
  );
};

export default Introduction; 